<template>
    <article
            class="video"
            @mouseenter="showPreview = true"
            @mouseleave="showPreview = false"
    >
        <router-link
                :to="{name: 'video.watch', params: {id: video.id}}"
        >
            <div
                    class="img"
                    :style="{ backgroundImage: `url('${backgroundImage}')` }"

            >
                <div
                        class="preview-wrapper"
                        :class="{active: showPreviewReal}"
                >
                    <template v-if="showPreviewReal">
                        <div
                                class="preview"
                                v-if="video.public_thumbnail_video_path"
                        >
                            <video
                                    disableRemotePlayback="false"
                                    width="100%"
                                    height="100%"
                                    autoplay="autoplay"
                                    loop="loop"
                                    :src="video.public_thumbnail_video_path"
                            ></video>
                        </div>
                        <div
                                class="preview-unavailable"
                                v-else
                        >
                        </div>
                    </template>
                </div>
                <span
                        v-if="video.is_hd"
                        class="hd"
                >
                  HD
                </span>
                <span
                        v-if="video.length"
                        class="length"
                >
                  {{videoLengthFormatted}}
                </span>
            </div>
        </router-link>
        <div class="text">
            <h4 class="name">
                {{video.name}}
            </h4>
            <!--<p class="description">
                {{video.description}}
            </p>-->
        </div>
    </article>
</template>
<script>
    export default {
        props: {
            video: {
                type: Object,
                required: true,
            }
        },
        data(){
            return {
                showPreview: false,
                showPreviewTimeout: false,
                showPreviewReal: false
            }
        },
        watch: {
            showPreview(showPreview){
                if(showPreview){
                    /*
                    if(this.video.public_thumbnail_video_path){
                        if(this.$refs.thumbnail_video !== undefined){
                            this.$refs.thumbnail_video.currentTime = 0;
                            this.$refs.thumbnail_video.play();
                        }
                    }*/

                    clearTimeout(this.showPreviewTimeout);

                    this.showPreviewReal = true;
                }else{
                    clearTimeout(this.showPreviewTimeout);

                    this.showPreviewTimeout = setTimeout(() => {
                        this.showPreviewReal = false;
                    }, 1000);
                }
            }
        },
        computed: {
            videoLengthFormatted(){
                if(this.video.length === null){
                    return null;
                }

                let videoDuration = (new Date(this.video.length * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

                if (videoDuration.startsWith('00:')){
                    return videoDuration.substr(3, videoDuration.length);
                }else{
                    return videoDuration;
                }

            },
            backgroundImage(){
                return this.video.public_thumbnail_image_path['small'];
                // return '/img/video-w.jpg';
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

    .video{
            flex-grow: 1;
            flex-basis: 0;
            padding-left: 5px;
            padding-right: 5px;

        .img{
            background-color: var(--pallete_secondary_color);
            position: relative;
            height: 200px;
            width: 100%;
            background-size: cover;
            background-position: center;
            margin-bottom: .5em;

            span.hd{
                position: absolute;
                left: 5px;
                top: 5px;
                padding: 3px;
                font-weight: bold;
                border-radius: 2px;
                background-color: var(--pallete_dark_color);
                color: #ffffff;
            }

            span.length{
                position: absolute;
                right: 5px;
                bottom: 5px;
                padding: 3px;
                border-radius: 2px;
                font-size: 13px;
                background-color: var(--pallete_dark_color);
                color: #ffffff;
            }

            .preview-wrapper{
                opacity: 0;
                transition:opacity .30s linear;

                &:hover{
                    opacity: 1;
                }
            }

            .preview-wrapper.active{

                .preview{
                    background-color: var(--pallete_dark_color);
                    position: absolute;
                    overflow:hidden;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    video{
                        overflow:hidden;
                        min-width: 100%;
                        min-height: 100%;
                    }
                }

                .preview-unavailable{
                    position: absolute;
                    top:0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background-color: rgba(0,0,0,.25);
                }
            }
        }

        .text{
            text-align: left;

            .description{
                margin: 0;
                color: var(--pallete_clear_text_color);
            }

            .name{
                margin: 0;
            }
        }
    }
</style>